export var CALENDAR_GREGORY = 'gregory';
export var CALENDAR_LONG = 'long';
export var CALENDAR_NARROW = 'narrow';
export var CALENDAR_SHORT = 'short';
export var DATE_FORMAT_2_DIGIT = '2-digit';
export var DATE_FORMAT_NUMERIC = 'numeric';


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/constants/date.js
// module id = SaOe
// module chunks = 5